import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonuses } from '../data/content';
const values = ['$5.000', '$6.000', '$7.000'];
export function Bonuses() {
  return <section className="w-full bg-white py-16 md:py-24" data-id="element-15" data-mp="plsnoebnvidz">
      <div className="mx-auto w-full max-w-content px-5 text-center md:px-8" data-id="element-16" data-mp="aua4y8rf39qx">
        <h2 className="inline-flex flex-wrap items-center justify-center gap-3 font-display text-[2rem] font-extrabold leading-tight tracking-tight text-ink md:text-5xl" data-id="element-17" data-mp="ftej7dt77xo4">
          <GiftIcon className="h-8 w-8 text-blue-600 md:h-10 md:w-10" aria-hidden="true" data-id="element-18" data-mp="5vqkydwdw817" />
          3 Bonos estratégicos
        </h2>
        <p className="mt-4 font-display text-sm font-extrabold uppercase tracking-[0.16em] text-blue-600" data-id="element-19" data-mp="3o2n1dr7wrsfy">
          Siempre incluidos
        </p>

        <ul className="mt-12 grid gap-5 md:grid-cols-3" data-id="element-20" data-mp="3t2j5rrkiplw1">
          {bonuses.map((bonus, index) => <li key={bonus.tag} className="flex h-full flex-col rounded-2xl bg-blue-50 p-6 text-left ring-1 ring-blue-100" data-id="element-21" data-mp="1m8fav7b6xtow" data-mpi={index}>
              <span className="font-display text-4xl font-extrabold tracking-tight text-blue-300" data-id="element-22" data-mp="3icvejinyew53">
                0{index + 1}
              </span>
              <span className="mt-3 text-xs font-extrabold uppercase tracking-[0.14em] text-blue-700" data-id="element-23" data-mp="3r6i5mvh7vb7y">
                {bonus.tag}
              </span>
              <h3 className="mt-2 font-display text-xl font-extrabold tracking-tight text-ink" data-id="element-24" data-mp="3n5ofrwk7rmcf">
                {bonus.title}
              </h3>
              <p className="mt-2 text-blue-900/75" data-id="element-25" data-mp="2ugr1e4j4i9oy">{bonus.description}</p>
              <p className="mt-auto flex items-center gap-3 pt-6" data-id="element-26" data-mp="2uiu0de297d5t">
                <span className="text-sm text-blue-900/45 line-through" data-id="element-27" data-mp="38h1vrhjn66ev">{values[index]}</span>
                <span className="rounded-lg bg-mint-50 px-3 py-1 font-display text-sm font-extrabold uppercase text-mint-600" data-id="element-28" data-mp="33ge4qvvexpkn">
                  Gratis
                </span>
              </p>
            </li>)}
        </ul>

        <div className="mx-auto mt-10 max-w-narrow rounded-2xl bg-blue-900 px-6 py-7 text-white" data-id="element-29" data-mp="it17uw0gwe50">
          <p className="font-display text-xs font-extrabold uppercase tracking-[0.18em] text-blue-200" data-id="element-30" data-mp="3cl0w9ayngol0">
            Valor total de los bonos
          </p>
          <p className="mt-3 font-display text-2xl font-extrabold tracking-tight md:text-3xl" data-id="element-31" data-mp="3lknxnwrdpue2">
            <span className="text-blue-300 line-through" data-id="element-32" data-mp="3qhmoa5bu3j7i">$18.000</span>{' '}
            <span className="ml-2" data-id="element-33" data-mp="2tsoq0d4vl35l">→ Gratis con tu MegaPack</span>
          </p>
        </div>
      </div>
    </section>;
}